<template>

  <v-app>
    <div class="d-flex flex-row">
      <div
          class="flex-row-auto offcanvas-mobile w-200px w-xl-300px"
          id="kt_profile_aside"
      >
        <div class="card card-custom card-stretch">
          <div class="card-body pt-4">
            <div class="d-flex justify-content-end">
              <KTDropdown2></KTDropdown2>
            </div>
            <div class="d-flex align-items-center">
              <div
                  class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
              >
                <div v-if="user.image_path && user.image_path.real"
                     class="symbol-label"
                     :style="{
                                  backgroundImage: `url(${user.image_path.real})`
                                }"
                ></div>
                <div v-else
                     class="symbol-label"
                     :style="{
                                  backgroundImage: `url('https://images.unsplash.com/photo-1509114397022-ed747cca3f65?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80')`
                                }"
                ></div>
                <i class="symbol-badge bg-success"></i>
              </div>
              <div>
                <a
                    class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                >{{ user.full_name ? user.full_name : 'N/A' }}</a
                >

                <div class="" v-if="checkUserIncludes(user.type,'student')">
                  {{
                    studentSetting.current_semester_title ? studentSetting.current_semester_title :
                        'N/A'
                  }}
                </div>
                <div class="" v-if="checkUserIncludes(user.type,'student')">
                  {{ studentSetting.program_title ? studentSetting.program_title : 'N/A' }}
                </div>
              </div>
            </div>
            <!--end::User-->
            <!--begin::Contact-->
            <!--          <per>{{user}}</per>-->
            <div class="py-9">
              <div class=" mb-2">
                <div class="font-weight-bold mr-2">CRN:</div>
                <div class="">{{ user.personal_id || 'N/A' }}</div>
              </div>
              <div class=" mb-2">
                <div class="font-weight-bold mr-2">Account Type:</div>
                <div class="">{{ user.account_type }}</div>
              </div>
              <div class=" mb-2" v-if="checkUserIncludes(user.type,'student')">
                <div class="font-weight-bold mr-2">Batch:</div>
                <div class="">{{ studentSetting.academic_year ? studentSetting.academic_year : 'N/A' }}</div>
              </div>
            </div>
            <!--end::Contact-->
            <!--begin::Nav-->
            <v-tabs
                class="menu-parent"
                v-model="tab"
                vertical

            >
              <!--                            <v-tabs-slider color="yellow"></v-tabs-slider>-->
              <v-tab>
                                <span class="navi-icon mr-2">
                                            <i class="far fa-id-card"></i>
                                          </span>
                <span class="navi-text">General</span>
              </v-tab>
              <v-tab>
                                <span class="navi-icon mr-2">
                                            <i class="far fa-id-card"></i>
                                          </span>
                <span class="navi-text">Timeline</span>
              </v-tab>
              <v-tab>
                               <span class="navi-icon mr-2">
                                  <i class="fas fa-coins"></i>
                                </span>
                <span class="navi-text">Fine</span>
              </v-tab>
              <v-tab>
                               <span class="navi-icon mr-2">
                                  <i class="fas fa-cogs"></i>
                                </span>
                <span class="navi-text">Settings</span>
              </v-tab>

            </v-tabs>

          </div>
        </div>
      </div>

      <!--begin::Content-->
      <div class="flex-row-fluid ml-lg-8">

        <b-tabs class="hide-tabs" v-model="tab">
          <!--        <b-tab active title="Overview">-->
          <!--          <KTProfileOverview></KTProfileOverview>-->
          <!--        </b-tab>-->
          <b-tab title="General">
            <StudentGeneralInformation v-if="user.id" :user="user" :setting="setting"
                                       @refresh="getUser"></StudentGeneralInformation>
          </b-tab>
          <b-tab title="General">
            <time-line v-if="user.id" :user="user"
                       @refresh="getUser"></time-line>
          </b-tab>
          <b-tab title="General">
            <fine v-if="user.id" :user="user" :library_fine="user.library_fine"
                  @update-library-fine="settleLibraryFine"></fine>
          </b-tab>
          <b-tab title="General">
            <student-setting v-if="user.id" :user="user" :setting="setting"></student-setting>
          </b-tab>


        </b-tabs>
      </div>
      <!--end::Content-->
    </div>

  </v-app>

</template>

<script>
import KTDropdown2 from "@/view/content/dropdown/Dropdown2";
import StudentGeneralInformation from "./profile/StudentGeneralInformation";
import StudentSetting from "./profile/Setting"
import Fine from "./profile/Fine"
import TimeLine from "@/view/pages/user/profile/TimeLine";

import UserService from "@/core/services/user/UserService";
import ProgramService from "@/core/services/level/program/ProgramService";
import GradeLevelService from "@/core/services/grade-level/GradeLevelService";
import AcademicClassService from "@/core/services/academic-class/AcademicClassService";
import AcademicYearService from "@/core/services/academic-year/AcademicYearService";
import LevelService from "@/core/services/level/LevelService";
import UserEnrollmentService from "@/core/services/user/UserEnrollmentService";

import ConfigService from "@/core/services/config/ConfigService";

const userService = new UserService();
const programService = new ProgramService();
const gradeLevelService = new GradeLevelService();
const academicClassService = new AcademicClassService();
const academicYearService = new AcademicYearService();
const levelService = new LevelService()
const enrollmentService = new UserEnrollmentService();

const configService = new ConfigService();
export default {
  name: "student-summary-page",
  components: {
    KTDropdown2,
    StudentGeneralInformation,
    StudentSetting, TimeLine, Fine
  },
  data() {
    return {
      tab: null,
      items: [
        'web', 'shopping', 'videos', 'images', 'news',
      ],
      text: '',
      tabIndex: 0,
      isBusy: false,
      studentSetting: {
        academic_year: null,
        current_semester_title: null,
        program_title: null,
        symbol_no: null,
        board_registration_number: null,
        midas_id: null,
        payment_frequency: null,
        admission_date: null,
        on_hold: null,
        is_course_complete: null,
        completion_date: null,
      },
      setting: {},
      user: {
        title: null,
        full_name: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        phone: null,
        description: null,
        father: null,
        mother: null,
        guardian: null,
        permanent_address: null,
        temporary_address: null,
        type: 'student',
        is_email_verified: null,
        is_active: null,
        dob: null
      }
    };
  },
  mounted() {
    this.id ? this.getUser() : "";
  },
  computed: {
    id() {
      return this.$route.params.id ? this.$route.params.id : false;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    routeTab() {
      return {
        title: `${this.user.full_name}`,
        tips: `Profile update for ${this.user.full_name}`
      }
    }
  },

  methods: {
    /**
     * Set current active on click
     * @param event
     */
    getUser() {
      userService.show(this.id).then(response => {
        this.user = response.data.user;
        this.user.is_active ? (this.user.is_active = true) : false;
        this.user.is_email_verified
            ? (this.user.is_email_verified = true)
            : false;
        this.setting = this.user.setting ? this.user.setting : {};
        // this.$refs["grades"].getUser(this.user.id);
      });
    },
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    },
    isAccessible(roles) {
      let flag = [];
      let type = this.currentUser.type;
      let userRoles = configService.getRoles(type);
      if (roles != null && roles != undefined && userRoles != null && userRoles != undefined) {
        roles = roles.split(",");
        for (let t of roles) {
          t = t.trim();
          if (userRoles.includes(t)) {
            flag.push(true);
          } else {
            flag.push(false);
          }
        }
        if (flag.includes(true)) {
          return true;
        }
      }
      return false;
    },
    checkUserIncludes(type, role) {
      if (type && type.length > 0 && type.includes(role))
        return true;
      return false;
    },
    settleLibraryFine(fine) {
      this.user.library_fine = fine ;
      userService.update(this.user.id, this.user).then(resource=>{
        this.getUser();
        this.$snotify.success("Library fine updated successfully")
      }).catch(error=>{
        this.$snotify.error("Something went wrong please try again later")
      })
    }
  },
};
</script>
<style scoped>
.menu-parent .v-tab {
  justify-content: flex-start !important;
}
</style>
